//pkg-form.tsx

import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import type { JSX } from "react";
import { Formik, Form, FastField, FieldProps, FormikHelpers } from "formik";
import * as yup from "yup";
import { FormControl, FormHelperText, Box } from "@mui/material";
import { AppTextField } from "./text-field";
import { validationMessages } from "../utils/validation/messages";
import { FormPrompt } from "./form-prompt";

export interface PkgFormValues {
  id: number;
  name: string;
  size: string;
  notes: string;
  archived: boolean;
}

export default function PkgForm(props: {
  children: JSX.Element;
  initialValues: PkgFormValues;
  saved: boolean;
  onSubmit: (
    values: PkgFormValues,
    helpers: FormikHelpers<PkgFormValues>,
  ) => void;
}) {
  return (
    <Formik
      initialValues={props.initialValues}
      validationSchema={yup.object({
        name: yup.string().required(validationMessages.Required),
        size: yup.string(),
        notes: yup.string().max(5000),
        archived: yup.boolean(),
      })}
      onSubmit={async (values, formikHelpers) => {
        await props.onSubmit(values, formikHelpers);
        formikHelpers.resetForm({ values });
      }}
    >
      {(form) => (
        <>
          <FormPrompt form={form} saved={props.saved} />
          <Form noValidate>
            <Box>
              <FormControl
                variant="standard"
                error={form.touched.archived && Boolean(form.errors.archived)}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      name="archived"
                      color="primary"
                      onChange={form.handleChange}
                      checked={form.values.archived}
                    />
                  }
                  label="Archived"
                />
                {form.touched.archived && form.errors.archived && (
                  <FormHelperText>{form.errors.archived}</FormHelperText>
                )}
              </FormControl>
            </Box>
            <FastField name="name">
              {(fieldProps: FieldProps) => (
                <AppTextField {...fieldProps} autoFocus label="Name" />
              )}
            </FastField>
            <FastField
  component={AppTextField}
  name="size"
  label="Size"
/>
            <FastField name="notes">
              {(fieldProps: FieldProps) => (
                <AppTextField
                  {...fieldProps}
                  multiline
                  label="Notes"
                  rows={4}
                />
              )}
            </FastField>
            <div>{props.children}</div>
          </Form>
        </>
      )}
    </Formik>
  );
}
